import { IS_COPYING_VALUE } from "@hub/settings/src/constants"

export default {
  loading: state => state.loading,
  getFlow: state => state.flow,
  isCopying: state => state.isCopying,
  isEditing: state => state.isEditing,
  uuid: state => state.uuid,
  getFlowPayload: state => {
    const flow = state.flow
    const payload = {
      name: flow.name,
      duplicated: state.isCopying ? IS_COPYING_VALUE.active : IS_COPYING_VALUE.inactive,
      mirrored_from_uuid: state.isCopying ? state.uuid : '',
      use_terms_acceptance: flow.useTermAcceptance,
      use_documents_attachment: flow.useDocumentAttachment,
      use_selfie_capture: flow.useSelfieCapture,
      validate_biometry: flow.validateBiometry,
      validate_liveness: flow.validateLiveness,
      use_manual_analysis: flow.useManualAnalysis,
      show_captured_document_preview: Boolean(flow.showCapturedDocumentPreview),
      show_attached_document_preview: Boolean(flow.showAttachedDocumentPreview),
      allow_refusal: flow.useBiometryRefusal,
      allow_correction_request: flow.useDataCorrectionRequest,
      accepted_document_types: flow.acceptedDocumentTypes,
      sale_flows: flow.saleFlows,
      accept_physical_as_digital: flow.acceptPhysicalAsDigital,
      accepted_digital_document_types: flow.acceptedDigitalDocumentTypes,
      version: flow.version
    }

    return payload
  }
}
